import { IKnmListFilterParams } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterParams';
import { apiPost } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmIndexPage } from '../interfaces/IKnmIndexPage';

export async function fetchKnmFindIndex(
  page: number,
  size: number,
  filter: IKnmListFilterParams | null,
  order?: string,
  isErp?: boolean,
): Promise<IKnmIndexPage> {
  const params = new URLSearchParams();

  params.append('page', String(page));
  params.append('size', String(size));
  if (order) {
    params.append('order', order);
  }

  return apiPost<IKnmIndexPage>({
    url: `${getServiceBaseURL(APIServiceEnum.INDEX_SERVICE, isErp)}/knm/find-indexes?${params}`,
    body: filter,
  });
}
